import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const PendingPrescription = () => import('./screens/index.vue')

const pendingPrescriptionsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.PENDING_PRESCRIPTION_VIEW,
    PERMISSIONS_KEYS.PENDING_PRESCRIPTION_EDIT,
  ])
) {
  pendingPrescriptionsRoutes.push({
    path: '/prescricao/confirma',
    name: 'Cadastro / Consulta|Rotina Confirma',
    component: PendingPrescription,
    meta: {
      icon: 'fa check',
      requiresAuth: true,
    },
  });
}

export { pendingPrescriptionsRoutes };

